"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subject = void 0;
var subject_level_1 = require("./subject-level");
/**
 * Дисциплина
 */
var Subject = /** @class */function () {
  function Subject(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'code', 'title', 'category_id', 'language_id', 'levels_category_id', 'banner', 'cover', 'cover_id', 'visit_info', 'stats'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.levels = (values.levels || []).map(function (v) {
      return new subject_level_1.SubjectLevel(v);
    });
  }
  return Subject;
}();
exports.Subject = Subject;
